export default "__VITE_ASSET__c5e38ce1__"